import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AffiliateRequest } from 'src/app/models/affiliate.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { AffiliateService } from 'src/app/services/affiliate.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-modal-create-affiliate',
  templateUrl: './modal-create-affiliate.component.html',
  styleUrls: ['./modal-create-affiliate.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalCreateAffiliateComponent implements OnInit {
  @Input() affiliate: AffiliateRequest = new AffiliateRequest();
  @Input() isCreating = true;
  @Output() close = new EventEmitter<boolean>();
  loading = false;
  vendors: VendorResponse[] = [];
  vendor = {
    value: '',
    verified: false,
    required: true,
    data: VendorResponse,
    class: "fa-asterisk",
    color: "danger",
    filterElements: []
  }

  constructor(
    private toastService: ToastrService,
    private vendorService: VendorService,
    private affiliateService: AffiliateService
  ) {

  }

  ngOnInit(): void {
    if (this.affiliate.nit){
      this.vendor.value = this.affiliate.nit;
      this.vendor.class = "fa-circle-check";
      this.vendor.color = "";
      this.vendor.verified = true;
    }
    this.getVendors();
  }

  getVendors() {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        this.vendors = response.data;
        this.vendor.filterElements = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  addPhoto() {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        var reader = new FileReader();
        reader.onload = (event) => {
          var dataURL = event.target.result;
          this.affiliate.foto = dataURL;
        };
        reader.readAsDataURL(file);
      } else {
        this.affiliate.foto = null;
      }
    }
    input.click();
  }

  write(event){
    var inputValue = event.target.value;
    this.vendor.filterElements = this.vendors.filter((vendor)=>{
      return vendor.name.toLowerCase().includes(inputValue.toLowerCase()) || vendor.nit.includes(inputValue)
    });
    this.affiliate.nit = inputValue;
    if (inputValue!=''){
      this.vendor.verified = true;
      this.vendor.class = "fa-circle-check";
      this.vendor.color = "";
    } else {
      this.vendor.verified = false;
      this.vendor.class = "fa-asterisk";
      this.vendor.color = "danger";
    }
  }

  select(vendor){
    this.affiliate.nit = vendor.nit;
    this.vendor.value = vendor.nit;
    this.vendor.verified = true;
    this.vendor.class = "fa-circle-check";
    this.vendor.color = "";
  }

  createOrEdit() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    if (this.isCreating) {
      this.affiliateService.newAffiliate(this.affiliate).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Afiliado creado exitosamente!");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      var temp = new AffiliateRequest();
      temp.celular = this.affiliate.celular;
      temp.direccion = this.affiliate.direccion;
      temp.dpi = this.affiliate.dpi;
      temp.foto = this.affiliate.foto;
      temp.mail = this.affiliate.mail;
      temp.nacimiento = this.affiliate.nacimiento;
      temp.nit = this.affiliate.nit;
      temp.nombre = this.affiliate.nombre;
      temp.vendorId = this.affiliate.vendorId;
      this.affiliateService.editAffiliate(this.affiliate['id'], temp).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Afiliado editado exitosamente!");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    }
  }
}
